export default __webpack_public_path__ + "760ce49bc063014209f3dbe4830aa70d.png";